import gql from "graphql-tag";

export const ADD_RESOURCES_ON_TRUCKING_DATAS = gql`
  mutation addResourcesOnTruckingDatas($where: AddResourceOnTruckingDatasInput!) {
    addResourcesOnTruckingDatas(where: $where)
  }
`;